module.exports = __webpack_public_path__ + "static/media/folha1.48ab6a46.png";